import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Thin Card wrapper that owns the loading / error / empty states so each
 * card component only has to render its happy-path content. The admin's
 * global error toast still fires (via setErrorReporter in main.tsx); this
 * wrapper adds the inline "retry" affordance for a card that failed.
 */
import React from 'react';
import { Alert, Button, Card, Skeleton } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
export function CardShell({ title, loading, error, onReload, skeletonRows = 3, extra, children, style, bodyStyle, }) {
    return (_jsx(Card, { title: title, extra: extra, style: style, styles: { body: bodyStyle }, children: error ? (_jsx(Alert, { type: "error", showIcon: true, message: "\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05D8\u05E2\u05D9\u05E0\u05D4", description: error, action: onReload ? (_jsx(Button, { size: "small", icon: _jsx(ReloadOutlined, {}), onClick: onReload, children: "\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1" })) : undefined })) : loading ? (_jsx(Skeleton, { active: true, paragraph: { rows: skeletonRows } })) : (children) }));
}
